import React from "react";
import { Edit2 } from "lucide-react";

type Props = {
  className?: string;
  size?: number;
};

export default function IconEdit({ className, size = 16 }: Props) {
  return <Edit2 className={className} width={size} height={size} />;
}
